import { User, Filters } from '@gower/shared-sdk/core/users';
import { UsersWithSpecialtiesService } from '@gower/cm-mdp-sdk/specialties';
import { ViewStatus } from '@gower/models-sdk/utils';
import { MessageBox } from '@gower/react-ui/message-box';
import { expose } from '@gower/react-ui/store';
import { DataGridStore } from '@gower/react-ui/template/data-grid';
import CredentialProvider from '../../app/credential-provider';

class UsersStore extends DataGridStore( User, Filters, { viewName: 'USERS' } )
{
    public readonly DownloadStatus = ViewStatus.new( 'ok' );

    protected onBeforeRender (): void {

        const isEmployee = CredentialProvider.isEmployee();
        if ( isEmployee ) {
            const option = this.Filters.Values.Group.Options.find( item => item.Id === User.VO.Group.Employee.Id );
            this.setFilter( this.Filters.Values.Group.KEY, option );
        }
    }

    async downloadList () {
        const service = UsersWithSpecialtiesService.get();
        this.DownloadStatus.setLoading();
        const file = await service.download();
        if ( file?.url ) {
            window.open( file.url );
        } else {
            await MessageBox.Error( service.LastErrors );
        }
        this.DownloadStatus.setOk();
    }

    async active ( item: User ) {
        if ( item && !item.Status.isActive ) {
            item.Status = User.VO.Status.Active;
            const result = await item.save();
            if ( !result.result ) {
                await MessageBox.Error( result.errorList );
            }
        }
    }

    async disable ( item: User ) {
        if ( item && !item.Status.isBloqued ) {
            item.Status = User.VO.Status.Bloqued;
            const result = await item.save();
            if ( !result.result ) {
                await MessageBox.Error( result.errorList );
            }
        }
    }


}

export const { useStore, provider } = expose( UsersStore );